const COMMON_PASSWORDS = new Set([
  '123456', 'password', '123456789', '12345678', '12345', 'qwerty',
  'abc123', 'senha', 'senha123', '111111', '000000', 'iloveyou',
])

export const analyzePassword = (password) => {
  if (!password) return null

  let charsetSize = 0
  if (/[a-z]/.test(password)) charsetSize += 26
  if (/[A-Z]/.test(password)) charsetSize += 26
  if (/[0-9]/.test(password)) charsetSize += 10
  if (/[^a-zA-Z0-9]/.test(password)) charsetSize += 32

  const entropy = password.length * Math.log2(charsetSize || 1)
  const isCommon = COMMON_PASSWORDS.has(password.toLowerCase())
  const hasRepeats = /(.)\1{2,}/.test(password)
  const hasSequence = /(012|123|234|345|456|567|678|789|abc|bcd|cde)/i.test(password)

  let score = 0
  if (password.length >= 8) score++
  if (password.length >= 12) score++
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[^a-zA-Z0-9]/.test(password)) score++
  if (isCommon || hasRepeats || hasSequence) score = Math.max(0, score - 2)

  const level = ['muito fraca', 'fraca', 'razoável', 'boa', 'forte', 'muito forte'][score]

  const issues = []
  if (password.length < 8) issues.push('Use pelo menos 8 caracteres.')
  if (!/[A-Z]/.test(password)) issues.push('Adicione letras maiúsculas.')
  if (!/[0-9]/.test(password)) issues.push('Adicione números.')
  if (!/[^a-zA-Z0-9]/.test(password)) issues.push('Adicione símbolos.')
  if (isCommon) issues.push('Essa é uma senha muito comum.')
  if (hasRepeats) issues.push('Evite repetir o mesmo caractere várias vezes seguidas.')
  if (hasSequence) issues.push('Evite sequências óbvias (123, abc).')

  return { score, level, entropy, issues }
}
